require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-locations-holiday-inn.json") })
        }
      }, "path---en-locations-holiday-inn");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-locations-holiday-inn!./.cache/json/en-locations-holiday-inn.json
// module id = 1054
// module chunks = 231608221292675